import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e15bfd70"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "p-mb-0" }, "Modification du pointage", -1))

import { EmployeeModelFragment, PointingModelFragment } from "@/graphql/types";
import PointingForm from "./PointingForm.vue";
import { useUpdatePointing } from "./hooks/useUpdatePointing";
import { getFullNames } from "@/utils/poiting";
import RemovePointing from "./RemovePointing.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdatePointing',
  props: {
    visible: { type: Boolean, default: false },
    pointing: {},
    employees: {}
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const { submit, form, pointingFormRef, submitForm } = useUpdatePointing({
  props,
  emit,
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: "Modifier le pointage",
    visible: _ctx.visible,
    containerStyle: { width: '50vw' },
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:visible', $event)))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createTextVNode(" " + _toDisplayString(_unref(getFullNames)(_ctx.employees)), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(RemovePointing, {
        "pointing-id": _ctx.pointing.id,
        onDone: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:visible', false)))
      }, null, 8, ["pointing-id"]),
      _createVNode(_component_Button, {
        disabled: _unref(form).times.$hasError,
        "icon-pos": "right",
        label: _ctx.$t('save'),
        onClick: _unref(submitForm),
        class: "p-button-success",
        icon: "pi pi-save"
      }, null, 8, ["disabled", "label", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(PointingForm, {
        onOnSubmit: _unref(submit),
        times: _unref(form).times.$value,
        "onUpdate:times": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).times.$value) = $event)),
        "previous-times": _unref(form).previous.$value,
        "onUpdate:previousTimes": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).previous.$value) = $event)),
        ref_key: "pointingFormRef",
        ref: pointingFormRef,
        date: _ctx.pointing.createdAt
      }, null, 8, ["onOnSubmit", "times", "previous-times", "date"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})